export default __webpack_public_path__ + "static/kalbe-logo-0709fdd7cba9232dc589825e7f68cda1.png";